import React, { useState, useEffect } from 'react';
import {
    Card, CardContent, Typography, Table, TableHead, TableBody,
    TableRow, TableCell, Chip, Box
} from '@mui/material';
import { customerAuth } from './customerAuth';

const CustomerOrderList = ({ refreshKey }) => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const response = await customerAuth.fetchWithAuth('/portal/orders');
                setOrders(await response.json());
            } catch (e) {
                console.error('Failed to load orders:', e);
            }
            setLoading(false);
        };
        load();
    }, [refreshKey]);

    if (loading) return <Typography>Loading orders...</Typography>;

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>My Orders</Typography>
                {orders.length === 0 ? (
                    <Typography color="text.secondary">No orders yet.</Typography>
                ) : (
                    <Box sx={{ overflowX: 'auto' }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Order #</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Items</TableCell>
                                    <TableCell>Delivery Date</TableCell>
                                    <TableCell>PO</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {orders.map(order => (
                                    <TableRow key={order.id}>
                                        <TableCell>{order.Order_Num}</TableCell>
                                        <TableCell>{order.Order_Date ? new Date(order.Order_Date).toLocaleDateString() : ''}</TableCell>
                                        <TableCell>{order.Order_Type}</TableCell>
                                        <TableCell>{order.item_count}</TableCell>
                                        <TableCell>{order.Delivery_Date ? new Date(order.Delivery_Date).toLocaleDateString() : ''}</TableCell>
                                        <TableCell>{order.PO_Num}</TableCell>
                                        <TableCell>
                                            <Chip
                                                label={order.Pending ? 'Pending' : 'Confirmed'}
                                                color={order.Pending ? 'warning' : 'success'}
                                                size="small"
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default CustomerOrderList;
